export default {
  hero: {
    status: 'Available for the right things',
    description: "Hi, I'm a multidisciplinary maker <br /> based in Curitiba, PR-Brazil",
    title: {
      first: 'Product',
      highlight: 'Design',
      last: 'Engineer',
    },
    scroll: 'Scroll',
  },
  about: {
    watermark: 'Who i am',
    title: 'who I am',
    seeMore: {
      label: 'Discover More',
      title: 'Get to know me',
    },
    story:
      "I grew up in the Caribbean, in a <span class='story-highlight'>Venezuela</span> that shaped me with toughness, good days, hard days, and a creativity born of urgency. There I learned to solve with little and to see order where others saw chaos. In 2019 I migrated to <span class='story-highlight'>Brazil</span> looking for stability and a brighter future. That leap forced me to start from scratch, reinvent myself, and prove that I could level up even on new ground.",
    heroCard: {
      role: 'Creative Developer & Interface Designer',
      bio: 'Passionate about creating digital experiences that truly connect with people. I combine the logic of code with the empathy of design to build useful solutions, focusing on removing friction to achieve interfaces that feel familiar and natural from the very first instant.',
    },
    locationCard: {
      label: 'Based in',
      country: 'Brazil',
    },
    availabilityCard: {
      status: 'Available',
      message: 'for the right thing',
    },
    quoteCard: {
      philosophy: '— My philosophy',
      segments: [
        { text: "I don't look for perfe", type: 'type' },
        { text: 'tion', type: 'type', isTypo: true },
        { text: '', type: 'pause', duration: 600 },
        { text: 'tion', type: 'delete' },
        { text: 'ction,', type: 'type' },
        { text: '', type: 'pause', duration: 800 },
        { text: ' I just try to be extraordinary.', type: 'type' },
      ],
    },
    experienceCard: {
      label: 'Years of<br />Experience',
    },
    neurodivergentCard: {
      teaser: "I have <span class='teaser__highlight'>superpowers</span>",
      button: 'Want to see?',
      label: 'Neurodivergent',
      hide: 'Hide',
      badges: {
        autism: 'Autism L1',
        giftedness: 'Giftedness',
      },
      superpowers: [
        { id: 'hyperfocus', name: 'Hyperfocus' },
        { id: 'patterns', name: 'Patterns' },
        { id: 'precision', name: 'Detail' },
        { id: 'logic', name: 'Logic' },
      ],
      footer: "Not a bug, it's a <span class='footer-highlight'>feature</span>",
    },
    hobbiesCard: {
      title: 'Beyond the System',
      text: "Faith, science and the drive to improve. A balance between God's design, physics laws and the discipline of breaking my own limits.",
      hobbies: [
        'God',
        'Family',
        'Science',
        'Physics',
        'Astrophysics',
        'Design',
        'Arts',
        'Music',
        'Gaming',
        'Dragon Ball',
      ],
    },
    readingCard: {
      title: 'Currently Reading',
    },
    familyCard: {
      title: "Family first <span class='family-card__hearts'>❤️</span>",
      text: 'My family is my strength when I falter, my joy when I am exhausted, and the reason I never stop. They are my priority, my solid ground, and my daily blessing. I thank God for guiding and sustaining us in every step.',
    },
    momentsCard: {
      title: 'Moments behind the pixels',
      labels: {
        alwaysLearning: 'Always learning 📚',
        dreamTeam: 'Dream Team 💜',
      },
    },
    setupCard: {
      items: {
        dell: { detail: 'Core i7 13th Gen • GEFORCE RTX • 32GB RAM • 1TB SSD' },
        mic: { detail: 'USB Condenser Mic' },
        webcam: { detail: 'Webcam 2k' },
        mouse: { detail: 'Mouse' },
        mousepad: { detail: 'Mousepad' },
        tablet: { detail: 'Tablet' },
        buds1: { detail: 'Wireless Earbuds' },
        buds2: { detail: 'Wireless Earbuds' },
        headphones: { detail: 'Over-Ear Headphones' },
        keyboard: { detail: 'Keyboard' },
        bible: { detail: 'Spiritual Guidance' },
        book: { detail: 'UX Book by Don Norman' },
        speaker: { detail: 'Smart Speaker' },
        monitor1: { detail: 'Full HD • IPS' },
        timer: { detail: 'Pomodoro Timer' },
        monitor2: { detail: 'Full HD • IPS' },
        controller: { detail: 'For gaming breaks 🎮' },
      },
    },
    languagesCard: {
      title: 'Languages',
      items: [
        { name: 'Spanish', level: 'Native' },
        { name: 'Portuguese', level: 'Fluent' },
        { name: 'English', level: 'B2 and Learning' },
      ],
    },
  },
  whatIDo: {
    title: {
      first: 'What I',
      highlight: 'Do',
    },
    services: {
      uiUx: {
        title: 'UI/UX',
        description:
          'Crafting intuitive, user-centric interfaces that blend aesthetics with seamless functionality',
      },
      frontend: {
        title: 'FRONTEND',
        description:
          'Engineering scalable, high-performance web applications using modern architecture',
      },
      design: {
        title: 'DESIGN',
        description:
          'Forging distinct visual identities and systems that tell a compelling brand story',
      },
      creative: {
        title: 'CREATIVE',
        description: 'Orchestrating immersive digital experiences where code meets art',
      },
    },
  },
  worksComingSoon: {
    badge: 'Under Construction',
    title: 'Parsing Ideas<br />Into Reality',
    description:
      "I'm currently curating a selection of my best projects to showcase here. Expect something special soon.",
    loading: {
      initializing: 'Initializing...',
      states: [
        'Improving User Cases...',
        'Designing User Flows...',
        'Optimizing Graphic Assets...',
        'Refining Interactions...',
        'Preparing Documentation...',
        'Compiling Best Projects...',
      ],
    },
  },
  journeyV2: {
    label: 'Career Timeline',
    title: 'Experience',
    connect: 'Connect on LinkedIn',
    items: [
      {
        id: 1,
        company: 'Compliance Soluções',
        role: 'Senior/Specialist UX Development Consultant',
        location: 'Remote - Ribeirão Preto, São Paulo, Brazil',
        period: 'May 2022 - Current',
        description:
          'Leading the UX migration of a legacy tax platform serving 100+ companies. Streamlining workflows for 20k+ monthly invoices through research, prototyping, and close collaboration with Product Owners.',
        startYear: 2022,
        endYear: 2025,
      },
      {
        id: 2,
        company: 'Simplify Tanzania',
        role: 'Art Director',
        location: 'Remote - Dar es Salaam, Tanzania',
        period: 'Jun 2019 - Dec 2022',
        description:
          'Led creative direction from MVP definition to frontend implementation. Designed high-fidelity interfaces for invoice management and established the visual brand identity across digital and social channels.',
        startYear: 2019,
        endYear: 2022,
        roles: [
          {
            title: 'Art Director',
            period: 'Feb 2021 - Oct 2022',
            type: 'Full-time',
          },
          {
            title: 'Senior UI/UX - Product Designer and Front-end Developer',
            period: 'Oct 2020 - Feb 2021',
            type: 'Contract',
          },
        ],
      },
      {
        id: 3,
        company: 'Katavi Gaming Limited',
        role: 'Senior UI/UX Product Designer Consultant',
        location: 'Remote - Dar es Salaam, Tanzania',
        period: 'Oct 2017 - May 2022',
        description:
          'Headed the UI/UX department for betting platforms, optimizing for device accessibility. Managed the full design cycle from research to launch using SCRUM, while defining corporate identity and marketing assets.',
        startYear: 2017,
        endYear: 2022,
        roles: [
          {
            title: 'Senior UI/UX Product Designer Consultant',
            period: 'Dec 2020 - May 2022',
            type: 'Freelance',
          },
          {
            title: 'UI/UX - Product Designer and Front-end Developer',
            period: 'Apr 2018 - Dec 2020',
            type: 'Full-time',
          },
          {
            title: 'Junior Front-end Developer and UI/UX Designer',
            period: 'Oct 2017 - Apr 2018',
            type: 'Full-time',
          },
        ],
      },
      {
        id: 4,
        company: 'Freelancer',
        role: 'Product Designer & Developer',
        location: 'Global',
        period: 'Jan 2016 -',
        description:
          'Providing versatile design and development solutions for global clients. Projects range from creating corporate identities and packaging for educational brands to designing interfaces for emerging gaming platforms.',
        startYear: 2016,
        endYear: 2025,
      },
    ],
  },
  testimonials: {
    title: 'Collaborative impact',
    subtitle:
      "I've had the pleasure of collaborating with some amazing people. Here's what they have to say.",
    items: [
      {
        id: 1,
        initials: 'J. A.',
        name: 'Jesus A. A. Rojas',
        role: 'Wharehouse Chief in Traslogistic de Venezuela',
        company: 'TBET',
        quote:
          "Juan has an incredible creativity power, he's a fast learner and self-taught person. He's got the ability to catch the project vision and use his skills to improve it or to add value.",
        linkedin: 'https://www.linkedin.com/in/jesus-armando-acosta-rojas/',
      },
      {
        id: 2,
        initials: 'B. C.',
        name: 'Baraka S. Cassian',
        role: 'Founder & Managing Director, Simplitech Ltd (Simplify)',
        company: 'SIMPLIFY',
        quote:
          'Working with Juan on Simplify’s product and frontend experience has been a pleasure. He quickly understood our product, our users, and the constraints we operate in, then translated loose ideas into clean, intuitive interfaces. I appreciated how he communicated clearly, iterated fast on feedback, and paid attention to the small details that make a product feel polished. Juan brings a rare mix of design craft, reliability, and genuine care for the outcome of the project. He is overall a friendly and great person to work with!',
        linkedin: 'https://www.linkedin.com/in/bcassian/',
      },
      {
        id: 3,
        initials: 'C. Z.',
        name: 'Carlos Zerpa',
        role: 'Senior Software Engineer',
        company: 'SIMPLIFY',
        quote:
          'Working alongside Juan Lias on the Simplify VFD project was a testament to his exceptional talent. His leadership in product design, coupled with his expertise in Vue.js, resulted in a polished, intuitive application. His professionalism, attention to detail, and collaborative spirit make him a standout designer and developer.',
        linkedin: 'https://www.linkedin.com/in/carlos-javier-zerpa/',
      },
      {
        id: 4,
        initials: 'M. V.',
        name: 'Mariana Vielma',
        role: 'Product Owner',
        company: 'SIMPLIFY',
        quote:
          'Juan is an extraordinary professional with incredible talent and a great sense of humor, making collaboration both productive and enjoyable. His designs always carry his signature "extra spark" that unique touch that elevates every project and leaves you wanting to see more of his work. He consistently gives 100% in everything he does, bringing creativity, attention to detail, and strong vision that add real value to any product or team.',
        linkedin: 'https://www.linkedin.com/in/mariana-vielma-67585a237/',
      },
    ],
  },
}
